import { TimeUnitApi } from 'api-typings/common/common';
import {
  DurationApi,
  SubscriptionHistoryLogApi,
} from 'api-typings/memberships/memberships_types';
import {
  Duration,
  MembershipSubscription,
} from './membership-subscriptions.model';

export function transformMembershipSubscription(
  membershipSubscription: SubscriptionHistoryLogApi,
): MembershipSubscription {
  return {
    id: membershipSubscription.id,
    packageId: membershipSubscription.package_id,
    timeStarted: membershipSubscription.time_started * 1000,
    timeEndedActual: membershipSubscription.time_ended_actual
      ? membershipSubscription.time_ended_actual * 1000
      : membershipSubscription.time_ended_actual,
    timeEndedExpected: membershipSubscription.time_ended_expected * 1000,
    priceId: membershipSubscription.price_id,
    periodId: membershipSubscription.period_id,
    status: membershipSubscription.status,
    userId: membershipSubscription.user_id,
    quantity: membershipSubscription.quantity,
    lastPaidTransactionId: membershipSubscription.last_paid_transaction_id,
    isTrial: membershipSubscription.is_trial,
    duration: transformDuration(membershipSubscription.duration),
  };
}

function transformDuration(duration: DurationApi): Duration {
  return {
    id: duration.id,
    type: duration.type || TimeUnitApi.MONTH,
    cycle: duration.cycle || 1,
  };
}
